module.exports = __webpack_public_path__ + "img/pad.bf01ee15.jpg";